module.exports = __webpack_public_path__ + "static/img/landing5-1.2dd89c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/landing5-1.png
// module id = Tyca
// module chunks = 0